import useAccount from './useAccount'
import useRouter from './useRouter'
import { IMPERSONATION_BANNER_HEIGHT } from '../components/system/ImpersonationBanner'

// Height of the fixed chrome at the top of the page (the app bar, plus the
// impersonation banner above it) — what a top-anchored snackbar must clear
// so it doesn't cover the nav. Matches Layout's main-content offset.
export const useSnackbarTopOffset = (): number => {
  const account = useAccount()
  const router = useRouter()
  const topBar = router.meta?.hideTopBar ? 0 : 64
  return topBar + (account.isImpersonating ? IMPERSONATION_BANNER_HEIGHT : 0)
}

export default useSnackbarTopOffset
